import FormControl from '@mui/material/FormControl';
import type { SxProps, Theme } from '@mui/material/styles';

import Select from 'shared/atoms/Select';
import type { BackgroundThemes } from 'shared/const';

import FormLabel from '../components/FormLabel';
import type { FormFieldProperties } from '../FormInput';

interface FormSelectProps {
  disabled?: boolean;
  handleChange?: (params: { name: string; value: unknown }) => void;
  id: string;
  infoText?: string;
  label: string;
  name: string;
  properties?: Record<string, FormFieldProperties>;
  required?: boolean;
  sx?: SxProps<Theme>;
  theme?: BackgroundThemes;
  values?: Record<string, unknown>;
}

const FormSelect = ({
  disabled: disabledProp,
  handleChange,
  id,
  infoText,
  label,
  name,
  properties = {},
  required: requiredProp,
  sx = {},
  theme: themeLayout = 'dark',
  values = {},
  ...props
}: FormSelectProps) => {
  const { disabled, required } = properties[name] || {};

  const onChangeHandler = ({
    name: targetName,
    value,
  }: {
    name: string;
    value: unknown;
  }) => {
    handleChange?.({ name: targetName, value });
  };

  return (
    <FormControl
      disabled={disabledProp === undefined ? disabled : disabledProp}
      fullWidth
      required={requiredProp === undefined ? required : requiredProp}
      sx={sx}
    >
      <FormLabel
        id={id}
        infoText={infoText}
        label={label}
        theme={themeLayout}
      />
      <Select
        id={id}
        name={name}
        onChange={onChangeHandler}
        theme={themeLayout}
        value={
          values[name] as
            | string
            | number
            | boolean
            | (string | number | boolean)[]
            | undefined
        }
        {...props}
      />
    </FormControl>
  );
};

export default FormSelect;
export type { FormSelectProps };
